module.exports = __webpack_public_path__ + "img/1.2db48be7.png";